import { Image } from "@mantine/core";
import React, { useEffect, useState } from "react";
import "./DetailUser.css";

interface RowDataUser {
  id: string;
  url: string;
  faculty: string;
  programe: string;
  short_name: string;
  name: string;
  role: string;
  number_true: string;
  creck: string;
  vut: string;
  type_std_name: string;
}

export default function DetailUser() {
  const [dataUser, SetdataUser] = useState<RowDataUser>();
  const LoadPage = () => {
    let rr: any = localStorage.getItem("dataUser");
    SetdataUser(JSON.parse(rr));
  };

  useEffect(() => {
    LoadPage();
  }, []);

  return (
    <div className="DetailUser">
      <div className="DetailUser-Image">
        <Image src={`${dataUser?.url}`} w={120} />
      </div>
      <div className="DetailUser-Title">
        <div className="DetailUser-row">
          <div className="DetailUser-Title-Bg">บัณฑิตลำดับที่</div>
          <div className="DetailUser-value">{dataUser?.number_true}</div>
        </div>
        <div className="DetailUser-row">
          <div className="DetailUser-Title-Bg">รหัสประจำตัว</div>
          <div className="DetailUser-value">{dataUser?.id}</div>
        </div>
        <div className="DetailUser-row">
          <div className="DetailUser-Title-Bg">ชื่อ - นามสกุล</div>
          <div className="DetailUser-value">{dataUser?.name}</div>
        </div>
        <div className="DetailUser-row">
          <div className="DetailUser-Title-Bg">ประเภทนักศึกษา</div>
          <div className="DetailUser-value">{dataUser?.type_std_name}</div>
        </div>
        <div className="DetailUser-row">
          <div className="DetailUser-Title-Bg">สังกัด</div>
          <div className="DetailUser-value">
            {dataUser?.faculty} สาขาวิชา{dataUser?.programe}
          </div>
        </div>
        <div className="DetailUser-row">
          <div className="DetailUser-Title-Bg">ระดับการศึกษา</div>
          <div className="DetailUser-value">{dataUser?.vut}</div>
        </div>
      </div>
    </div>
  );
}
